import { render } from "./CoBrandNova.vue?vue&type=template&id=841a9c36&scoped=true"
import script from "./CoBrandNova.vue?vue&type=script&lang=js"
export * from "./CoBrandNova.vue?vue&type=script&lang=js"

import "./CoBrandNova.vue?vue&type=style&index=0&id=841a9c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-841a9c36"]])

export default __exports__